/* Gamdru: añade un pill "Te ahorras X€ frente al precio de nuevo" (o el
 * % si el ahorro es pequeño) justo debajo del precio, calculado a partir
 * del precio tachado (compare-at). Se recalcula solo si la variante
 * seleccionada cambia el precio.
 *
 * El componente <product-price> de Shopify no sustituye su contenido al
 * cambiar de variante: deja el div de precio anterior abandonado dentro
 * de sí mismo (sin el atributo ref="priceContainer", que solo lleva el
 * más reciente) y añade uno nuevo al lado. Por eso, en cada pasada,
 * primero limpiamos esos restos dentro de cada <product-price> y nos
 * quedamos solo con el último antes de decidir dónde va el pill. */
(function () {
  var SAVINGS_THRESHOLD = 5; // por debajo de esto, se muestra en % en vez de en €

  function parseAmount(text) {
    return parseFloat(text.replace(/[^\d,.]/g, '').replace(',', '.'));
  }

  function buildText(price, compare, compact) {
    var savings = compare - price;
    if (!(savings > 0)) return null;
    if (savings >= SAVINGS_THRESHOLD) {
      var amount = savings.toFixed(2).replace('.', ',') + '€';
      return compact ? '-' + amount : 'Te ahorras ' + amount + ' frente al precio de nuevo';
    }
    var pct = Math.round((savings / compare) * 100);
    return compact ? '-' + pct + '%' : 'Te ahorras un ' + pct + '% frente al precio de nuevo';
  }

  function buildOfferText(price, previous, compact) {
    var savings = previous - price;
    if (!(savings > 0)) return null;
    var pct = Math.round((savings / previous) * 100);
    var previousText = previous.toFixed(2).replace('.', ',') + '€';
    if (compact) return 'Oferta -' + pct + '%';
    return 'Oferta: -' + pct + '% extra | Normalmente ' + previousText;
  }

  function pruneStaleContainers() {
    document.querySelectorAll('main product-price').forEach(function (pp) {
      // Solo nos interesan los divs que de verdad contienen precio (no
      // el div de "pago a plazos" ni ningún otro hijo legítimo).
      var divs = Array.prototype.filter.call(pp.children, function (el) {
        return el.tagName === 'DIV' && el.querySelector('.price, .compare-at-price');
      });
      // Todos menos el último son restos de renders anteriores de ESE
      // mismo bloque de precio: fuera, junto con su fila de pills.
      for (var i = 0; i < divs.length - 1; i++) {
        var next = divs[i].nextElementSibling;
        if (next && next.classList && next.classList.contains('gsv-badge-row')) next.remove();
        divs[i].remove();
      }
    });
  }

  function reconcile() {
    pruneStaleContainers();

    var validRows = [];
    var offerPrevious = typeof window.gamdruOfferPreviousPrice === 'number' ? window.gamdruOfferPreviousPrice : null;

    document.querySelectorAll('main [ref="priceContainer"]').forEach(function (container) {
      // Solo en la ficha de producto: nada de pills en tarjetas de
      // colecciones, "lo más vendido", buscador, etc.
      if (container.closest('.resource-card, product-card, .card')) return;

      var compact = !!container.closest('.sticky-add-to-cart');
      var compareEl = container.querySelector('.compare-at-price');
      var priceEl = container.querySelector('.price:not(.compare-at-price)');
      var price = priceEl ? parseAmount(priceEl.textContent) : null;
      var text = (compareEl && priceEl) ? buildText(price, parseAmount(compareEl.textContent), compact) : null;
      var offerText = (offerPrevious && priceEl) ? buildOfferText(price, offerPrevious, compact) : null;

      if (!text && !offerText) return;

      // En la barra flotante, los pills van debajo del título/nombre del
      // producto, no junto al precio (ahí no hay sitio).
      var info = compact ? container.closest('.sticky-add-to-cart').querySelector('.sticky-add-to-cart__info') : null;
      var row;
      if (info) {
        row = info.querySelector(':scope > .gsv-badge-row');
        if (!row) {
          row = document.createElement('div');
          row.className = 'gsv-badge-row gsv-badge-row--compact';
          info.appendChild(row);
        }
      } else {
        var next = container.nextElementSibling;
        row = (next && next.classList && next.classList.contains('gsv-badge-row')) ? next : null;
        if (!row) {
          row = document.createElement('div');
          row.className = 'gsv-badge-row';
          container.after(row);
        }
      }

      var badge = row.querySelector('.gsv-badge');
      if (text) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'gsv-badge';
          row.appendChild(badge);
        }
        if (badge.textContent !== text) badge.textContent = text;
      } else if (badge) {
        badge.remove();
      }

      var offerBadge = row.querySelector('.gsv-offer-badge');
      if (offerText) {
        if (!offerBadge) {
          offerBadge = document.createElement('span');
          offerBadge.className = 'gsv-offer-badge';
          row.appendChild(offerBadge);
        }
        if (offerBadge.textContent !== offerText) offerBadge.textContent = offerText;
      } else if (offerBadge) {
        offerBadge.remove();
      }

      // El precio se muda a esa misma fila (a la derecha), dejando el
      // título solo en su propia línea arriba, con todo el ancho.
      if (info) {
        container.classList.add('gsv-sticky-price');
        if (info.lastElementChild !== container) info.appendChild(container);
      }

      validRows.push(row);
    });

    document.querySelectorAll('.gsv-badge-row').forEach(function (r) {
      if (validRows.indexOf(r) === -1) r.remove();
    });
  }

  var scheduled = false;
  function scheduleReconcile() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      reconcile();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReconcile);
  } else {
    scheduleReconcile();
  }

  new MutationObserver(scheduleReconcile).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
